module.exports = __webpack_public_path__ + "img/cloudview-poster-1.cca0fbac.jpg";